import { z } from 'zod'

import { FUNDING_INSTRUMENTS } from '@/pages/instruments/new-instrument/constants/funding-instruments'
import { PRICE_TYPES } from '@/pages/instruments/new-instrument/constants/price-types'
import {
  FUNDED_RETURN_TYPES,
  FUNDING_RETURN_TYPES,
} from '@/pages/instruments/new-instrument/constants/return-types'
import { baseInstrumentSchema } from '@/pages/instruments/new-instrument/schemas/shared/base.schema'

export const diverOtcSchema = baseInstrumentSchema.extend({
  instrument_type: z.literal('diver-otc'),
  structure_name: z.string().min(1),
  underlying_instrument_id: z.number().int().positive(),
  fund_id: z.number().int().positive(),
  currency_id: z.number().int().positive(),
  counterparty_id: z.number().int().positive(),
  notional: z.number().nullable(),
  trade_id: z.string().nullable(),
  effective_date: z.iso.date(),
  maturity_date: z.iso.date(),
  first_floater_settlement_date: z.iso.date(),
  penultimate_floater_settlement_date: z.iso.date(),
  cash_settlement_payment_date: z.iso.date(),
  funding_instrument: z.enum(FUNDING_INSTRUMENTS).nullable(),
  leverage: z.number(),
  price_type: z.enum(PRICE_TYPES),
  floater_spread_bps: z.number(),
  swap_payments_yearly: z.number().int().positive(),
  funding_return_type: z.enum(FUNDING_RETURN_TYPES),
  funded_return_type: z.enum(FUNDED_RETURN_TYPES),
  bucket_id: z.number().int().positive().nullable(),
})

export type DiverOtcSchemaType = z.infer<typeof diverOtcSchema>
